import { render, staticRenderFns } from "./categorywisechart.vue?vue&type=template&id=b62236b2&scoped=true&"
import script from "./categorywisechart.vue?vue&type=script&lang=js&"
export * from "./categorywisechart.vue?vue&type=script&lang=js&"
import style0 from "./categorywisechart.vue?vue&type=style&index=0&id=b62236b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62236b2",
  null
  
)

export default component.exports